// @module Eureka.MaxaTrendingProducts.TrendingProcuts
define('Eureka.MaxaTrendingProducts.OurTeam.View'
    ,	[
        'PageType.Base.View',
        'eureka_maxatrendingproducts_ourteam.tpl'
    ]
    , function (
        PageTypeBaseView,
        eureka_maxatrendingproducts_ourteam_tpl
    )
    {
        'use strict';

        // @class Eureka.MaxaTrendingProducts.TrendingProcuts.View @extends Backbone.View
        return PageTypeBaseView.PageTypeBaseView.extend({

            template: eureka_maxatrendingproducts_ourteam_tpl

            ,	initialize: function (options) {


            }

            ,beforeShowContent: function beforeShowContent () {
                this.getBreadcrumbPages = function () {
                    return [{
                        text: 'About Us',
                        href: '/about-us'
                    },{
                        text: 'Our Team',
                        href: ''
                    }];
                };
                return jQuery.Deferred().resolve()

            }

            //@method getContext @return Eureka.MaxaTrendingProducts.TrendingProcuts.View.Context
            ,	getContext: function getContext()
            {
                return {
                };
            }
        });
    });
